export const profilePageLayoutByVariant = {
  desktop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 156,
      right: 0,
    },
    pl: 156,
    pr: 156,
    px: 156,
  },
  laptop: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
  mobile: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
  tablet: {
    header: {
      left: 0,
      position: 'absolute',
      px: 24,
      right: 0,
    },
    pl: 24,
    pr: 24,
    px: 24,
  },
};

export const tagsProps = [
  {
    key: 'minutes_count',
    keyTag: 'time',
    translationName: 'ProfilePage.MinutesShort',
  },
  {
    key: 'lessons_count',
    keyTag: 'material',
    translationName: 'ProfilePage.Lessons',
  },
  {
    key: 'isTest',
    keyTag: 'test',
    translationName: 'ProfilePage.Test',
  },
  {
    key: 'peoplePassed',
    keyTag: 'peoplePassed',
    translationName: 'ProfilePage.PeoplePassed',
  },
];

export const modulesProps = [
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 12,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: 'Principle of Distinction',
  },
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 13,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: '2Principle of Distinction',
  },
  {
    description:
      'This course is designed for soldiers, focusing on the practical application of International Humanitarian Law (IHL) in combat situations. It covers the basics of the Geneva Conventions, rules of engagement, and the ethical considerations soldiers must navigate in the field.',

    id: 122,
    image:
      'https://buffer.com/cdn-cgi/image/w=1000,fit=contain,q=90,f=auto/library/content/images/size/w1200/2023/10/free-images.jpg',
    isTest: true,
    lessons: 6,
    minutes_count: 5,
    module: 2,
    peoplePassed: '150k',
    title: '3Principle of Distinction',
  },
];

export const formatDate = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
